import { Amplify } from "aws-amplify";
import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import Layout from "./common/components/layout/Layout";
import LoadingProvider from "./common/context/LoadingProvider";
import { NavbarOfferProvider } from "./common/context/NavbarOfferContext";
import translations from "./translations.json";
import { addFederatedToUrl } from "./utils";

const callback_url_local = "http://localhost:3000";
const callback_url_dev = "https://d3j7gddkx7w17z.cloudfront.net";
const callback_url_prod = "https://fyndr.perelyn.com";

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_USERPOOLID || "",
      userPoolClientId: process.env.REACT_APP_USERPOOLAPPCLIENTID || "",
      loginWith: {
        oauth: {
          domain: "alqemi-v2-" + process.env.REACT_APP_ENV + "-auth.auth.eu-central-1.amazoncognito.com",
          scopes: ["email", "openid", "profile"],
          redirectSignIn: [
            addFederatedToUrl(callback_url_local),
            addFederatedToUrl(callback_url_dev),
            addFederatedToUrl(callback_url_prod),
          ],
          redirectSignOut: [
            callback_url_local,
            callback_url_dev,
            callback_url_prod,
          ],
          responseType: "code",
          providers: [{ custom: "AzureAD" }],
        },
      },
    },
  },
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

export default function App() {
  i18next.use(initReactI18next).init({
    resources: translations,
    lng: localStorage.getItem("language") || "de",
    interpolation: {
      escapeValue: false,
    },
  });
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <NavbarOfferProvider>
          <LoadingProvider>
            <Layout />
          </LoadingProvider>
        </NavbarOfferProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
